import type { ReactNode } from "react";
import { useCallback } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg width="35px" height="31px" viewBox="0 0 35 31" version="1.1">
        <title>undo</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="LS-Menu"
                transform="translate(-609.000000, -14.000000)"
                stroke={color}
            >
                <g id="undo">
                    <g transform="translate(608.750000, 14.000000)">
                        <polyline
                            id="Shape"
                            points="1 23 34 23 34 1 10.4285714 1"
                        />
                        <polyline
                            id="Shape"
                            strokeLinecap="square"
                            points="9 15 1 23 9 31"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

interface UndoButtonProps extends Partial<React.ComponentProps<typeof Button>> {
    mode: string;
    onClick?: () => void;
    onGlobalUndo: () => void;
    onModeUndo: () => void;
}

const UndoButton = (props: UndoButtonProps) => {
    const { mode, onGlobalUndo, onModeUndo, onClick, ...buttonProps } = props;

    const handleClick = useCallback(() => {
        onClick?.();
        if (mode === "view") {
            onGlobalUndo();
        } else {
            onModeUndo();
        }
    }, [mode, onGlobalUndo, onModeUndo, onClick]);

    return (
        <Button
            {...buttonProps}
            onClick={handleClick}
            renderIcon={renderIcon}
        />
    );
};

/**
 * Determines whether the undo action is disabled based on mode history and paste state.
 *
 * @param map - The Redux map state containing mode history.
 * @returns Whether the undo action is disabled.
 */
const isDisabled = (map: any) =>
    map.general.mode.name === "view"
        ? map.values.global.past.length === 0
        : map.values.mode.past.length === 0 || map.general.pasteMode.activated;

const mapStateToProps = ({ map }: { map: any }) => {
    return {
        disabled: isDisabled(map),
        mode: map.general.mode.name,
    };
};

const mapDispatchToProps = {
    onGlobalUndo: actions.map.values.global.undo,
    onModeUndo: actions.map.values.mode.undo,
};

export default connect(mapStateToProps, mapDispatchToProps)(UndoButton);
